class ProductSelector extends HTMLElement {
  constructor() {
    super();

    this.productWrapper = this.closest('[data-product-wrapper]');
    this.mediaWrapper = this.productWrapper?.querySelector(
      '[data-media-wrapper]',
    );
    this.form = document.querySelector(
      `form#${this.getAttribute('data-form-id')}`,
    );
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.submitButton = this.form.elements['add'];
    this.submitButtonValue =
      this.submitButton?.querySelector('[data-value]') || this.submitButton;
    this.cartDrawer = document.querySelector('cart-drawer');
    this.variants = JSON.parse(
      this.querySelector('[data-variants-json][type="application/json"]')
        .textContent,
    );
    this.prices = JSON.parse(
      this.querySelector('[data-variants-prices]').textContent,
    );
    this.addEventListener('change', this.onVariantChange.bind(this));
    this.unavailableText = ` - ${this.dataset.unavailableText}`;
    this.floatingButton = document.querySelector(
      `floating-button[data-product-form-id="${this.dataset.formId}"]`,
    );
    this.floatingButtonPrice =
      this.floatingButton?.querySelector('[data-price]');

    this.radioInputSwatches = this.querySelectorAll('input[type="radio"]');

    if (this.dataset?.autoplayEnabled && this.dataset.autoplayEnabled === "true" && this.mediaWrapper && this.radioInputSwatches) {
      this.autoplaySpeed = this.dataset.autoplaySpeed ?? 5000;
      setTimeout(this.initProductChangeInterval.bind(this), 3000);
    }
  }

  connectedCallback() {
    this.updateOptions();
    this.filterOptions();
  }

  onSubmitHandler(event) {
    event.preventDefault();

    this.submitButton.classList.add('disabled');

    const formData = new FormData(this.form);
    formData.append(
      'sections',
      this.cartDrawer.getSectionsToRender().map((section) => section.section),
    );
    formData.append('sections_url', window.location.pathname);

    Cart.add(formData)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.handleErrorMessage(response.description);
          return;
        }

        this.cartDrawer.renderContents(response);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        this.submitButton.classList.remove('disabled');
      });
  }

  handleErrorMessage(errorMessage = false) {
    const errorWrapper = this.querySelector('[data-error-wrapper]');
    if (!errorWrapper || !errorMessage) return;

    window.dispatchEvent(
      new CustomEvent('formError', { detail: errorMessage }),
    );
    errorWrapper.classList.toggle('hidden', !errorMessage);

    if (typeof errorMessage == 'string') {
      errorWrapper.textContent = errorMessage || '';
    }
  }

  onVariantChange(event) {
    if (event.target.type === 'number') return;
    this.updateOptions();
    this.updateVariant();
    this.toggleAddButton(false, '');
    this.handleErrorMessage();
    this.filterOptions();
    this.updateMedia();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '');
      this.setUnavailable();

      return;
    }

    if (!this.currentVariant.available) {
      ``;
      this.toggleAddButton(true, window.variantStrings.soldOut);
    }

    this.updateVariantInput();
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll('input[type="radio"]:checked, select'),
      (el) => ({ name: el.dataset.name, value: el.value }),
    );
  }

  updateVariant() {
    this.currentVariant = this.variants.find((variant) => {
      return !variant.options
        .map((option, index) => this.options[index].value === option)
        .includes(false);
    });

    this.currentVariantPrice = this.prices.find((priceObj) => {
      return priceObj.id == this.currentVariant.id;
    });
  }

  updateVariantInput() {
    const input = this.querySelector('[name="id"]');
    input.value = this.currentVariant.id;
  }

  setUnavailable() {
    const price = this.querySelector(`#price-${this.dataset.sectionId}`);

    if (this.floatingButton) this.floatingButton.classList.add('disabled');

    if (!this.submitButton) return;
    this.submitButtonValue.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visually-hidden');
  }

  toggleAddButton(disable, text) {
    if (disable) {
      if (this.floatingButton) this.floatingButton.classList.add('disabled');

      this.submitButton.setAttribute('disabled', 'disabled');
      if (text) this.submitButtonValue.textContent = text;
    } else {
      if (this.floatingButton) this.floatingButton.classList.remove('disabled');

      this.submitButton.removeAttribute('disabled');
      this.submitButtonValue.textContent =
        this.submitButtonValue.dataset.value || window.variantStrings.addToCart;
    }
  }

  renderProductInfo() {
    const params = new URLSearchParams(window.location.search);
    params[params.has('variant') ? 'set' : 'append'](
      'variant',
      this.currentVariant.id,
    );
    params.append('section_id', this.dataset.sectionId);

    fetch(`${this.dataset.url}?${params.toString()}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destinationPrice = document.querySelector(
          `#price-${this.dataset.sectionId}`,
        );
        const sourcePrice = html.querySelector(
          `#price-${this.dataset.sectionId}`,
        );

        if (this.floatingButtonPrice && sourcePrice) {
          this.floatingButtonPrice.innerHTML = sourcePrice.innerHTML;
        }

        if (destinationPrice && sourcePrice) {
          destinationPrice.classList.remove('visibility-hidden');
          destinationPrice.innerHTML = sourcePrice.innerHTML;
        }
      });
  }

  initProductChangeInterval() {
    this.productChangeInterval = setInterval(this.triggerProductChange.bind(this), this.autoplaySpeed);
    // when user clicks away from tab pause interval
    document.addEventListener('visibilitychange', this.toggleProductChangeInterval.bind(this));
    // when user clicks on swatch disable the interval
    for (var i=0;i<this.radioInputSwatches.length;i++) {
      this.radioInputSwatches[i].addEventListener("click", this.stopProductChangeInterval.bind(this));
    }
  }
  triggerProductChange() {
    //console.log("trigger product change");
    const checkboxes = Array.from(this.radioInputSwatches);
    const activeCB = checkboxes.filter(input => { return input.checked })[0];
    const activeIndex = checkboxes.indexOf(activeCB);
    let nextActive;
    if (activeIndex === 0) {/* is first */
      nextActive = this.radioInputSwatches[1];
    }
    else if (activeIndex === checkboxes.length - 1) {/* is last */
      nextActive = this.radioInputSwatches[0];
    }
    else {
      nextActive = this.radioInputSwatches[activeIndex+1];
    }
    if (!nextActive) { console.warn("no next active found"); return; }
    nextActive.checked = true;
    // must dispatch change event or the product image will not change
    this.dispatchEvent(new CustomEvent("change", { target: { type: "custom-event" } }));
  }
  toggleProductChangeInterval() {
    //console.log("visibility change", this.productChangeInterval);
    if (this.productChangeInterval === false) return;
    if (document.visibilityState == 'visible') this.productChangeInterval = setInterval(this.triggerProductChange.bind(this), this.autoplaySpeed);
    else clearInterval(this.productChangeInterval);
  }
  stopProductChangeInterval() {
    clearInterval(this.productChangeInterval);
    //console.log("interval stopped");
    this.productChangeInterval = false;
  }

  /**
   * Filter unavailable options.
   */
  filterOptions() {
    for (const [key, { name }] of this.options.entries()) {
      this.querySelectorAll(`[data-name="${name}"]`).forEach((swatch) => {
        const selectOptions = swatch.querySelectorAll('option');
        if (selectOptions.length) {
          return selectOptions.forEach((option) => {
            if (this.isOptionAvailable(key, option.value)) {
              return (option.innerHTML = option.innerHTML.replace(
                this.unavailableText,
                '',
              ));
            }

            if (option.innerHTML.includes(this.unavailableText)) return;

            option.innerHTML = `${option.innerHTML}${this.unavailableText}`;
          });
        }

        return swatch.classList.toggle(
          'is-unavailable',
          !this.isOptionAvailable(key, swatch.value),
        );
      });
    }
  }

  /**
   * Check if at least one available variant that contains this option exists.
   *
   * @param {Number} index
   * @param {String} value
   * @returns {Boolean}
   */
  isOptionAvailable(index, value) {
    return this.variants.some((variant) => {
      if (!variant.available) return false;

      const valuesToCheck = {};
      for (let i = 0; i < index; i++) {
        const optionHandle = `option${i + 1}`;
        const optionValue = this.options[i].value;
        valuesToCheck[optionHandle] = optionValue;
      }
      const currentHandle = `option${index + 1}`;
      valuesToCheck[currentHandle] = value;
      return Object.entries(valuesToCheck).every(
        ([handle, value]) => variant[handle] === value,
      );
    });
  }

  updateMedia() {console.log("new active media",newActiveMedia);
    if (!(this.mediaWrapper && this.currentVariant)) return;

    const activeMedia = this.mediaWrapper.querySelector('.is-visible');
    const newActiveMedia = this.mediaWrapper.querySelector(
      `[data-variant-id="${this.currentVariant.id}"]`,
    );

    if (!newActiveMedia) return;

    activeMedia?.classList.remove('is-visible');
    newActiveMedia.classList.add('is-visible');
  }
}

customElements.define('product-selector', ProductSelector);